<template>
    <div class="row">
        <StudyProductSubscriptionItem v-for="(item, index) in subscriptions"
                                     :key="item.idsubscription"
                                     :last-item="index === subscriptions.length - 1"
                                     :subscription="item"
                                     @order="order"/>
    </div>
</template>

<script>
    import StudyProductSubscriptionItem from "./StudyProductSubscriptionItem";

    export default {
        name: "StudyProductSubscriptionList",
        components: {StudyProductSubscriptionItem},
        props: {
            subscriptions: {
                type: Array,
                required: true,
            },
        },
        methods: {
            order(subscription) {
                this.$emit('order', subscription)
            },
        }
    }
</script>

<style scoped>

</style>
